<script setup>
import {Link} from '@inertiajs/vue3';
import {ref} from "vue";
import ConfirmDeleteModal from "@/Components/TeamManagement/confirmDeleteModal.vue";
import ConfirmLeaveModal from "@/Components/TeamManagement/confirmLeaveModal.vue";

const props = defineProps({
	auth: {type: Object},
});

const deleteModalOpen = ref(false);
const leaveModalOpen = ref(false);

</script>

<template>
	<div class="bg-white shadow sm:rounded-lg">
		<div class="px-4 py-5 mb-4">

			<div class="flex items-center justify-between">

				<div class="flex">
					<img :src="'https://www.google.com/s2/favicons?domain=' + auth.user.current_team.domain + '&sz=256'" class="h-6 m-2" >

					<div class="block pl-3"><div class="text-gray-500 text-xs">Team Name</div>
						<div class="text-gray-700">{{ auth.user.current_team.name }}</div>
					</div>

					<div class="block pl-8"><div class="text-gray-500 text-xs">Email Domain</div>
						<div class="text-gray-700">{{ auth.user.current_team.domain }}</div>
					</div>

					<div class="block pl-8"><div class="text-gray-500 text-xs">Role</div>
						<div class="text-gray-700">{{ auth.user.isAdminOfCurrentTeam ? 'Admin' : 'User' }}</div>
					</div>
				</div>


				<div>
					<div class="mt-5 sm:ml-6 sm:mt-0 sm:flex sm:flex-shrink-0 sm:items-center">
						<span v-if="auth.user.isAdminOfCurrentTeam" class="flex-1 sm:flex-initial ml-2">
							<button @click="deleteModalOpen = !deleteModalOpen" type="button" data-heap="delete-team-start"
									class="w-full inline-flex rounded-md border border-gray-300 hover:border-red-500 p-2 bg-white text-gray-700 shadow-sm hover:text-red-500 cursor-pointer focus:outline-none transition ease-in-out duration-150 text-xs sm:leading-5">
								<svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor" class="w-5 h-5">
									<path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
								</svg>
								<span class="ml-1 text-xs text-center w-full leading-3 self-center">Delete</span>
							</button>
						</span>

						<span class="flex-1 sm:flex-initial ml-2">
							<button  @click="leaveModalOpen = !leaveModalOpen" type="button" data-heap="leave-team-start"
									class="w-full inline-flex rounded-md border border-gray-300 hover:border-orange-500 p-2 bg-white text-gray-700 shadow-sm hover:text-orange-500 cursor-pointer focus:outline-none transition ease-in-out duration-150 text-xs sm:leading-5">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
									<path fill-rule="evenodd" d="M3 4.25A2.25 2.25 0 0 1 5.25 2h5.5A2.25 2.25 0 0 1 13 4.25v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 0-.75-.75h-5.5a.75.75 0 0 0-.75.75v11.5c0 .414.336.75.75.75h5.5a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 1 1.5 0v2A2.25 2.25 0 0 1 10.75 18h-5.5A2.25 2.25 0 0 1 3 15.75V4.25Z" clip-rule="evenodd" />
									<path fill-rule="evenodd" d="M6 10a.75.75 0 0 1 .75-.75h9.546l-1.048-.943a.75.75 0 1 1 1.004-1.114l2.5 2.25a.75.75 0 0 1 0 1.114l-2.5 2.25a.75.75 0 1 1-1.004-1.114l1.048-.943H6.75A.75.75 0 0 1 6 10Z" clip-rule="evenodd" />
								</svg>

								<span class="ml-1 text-xs text-center w-full leading-3 self-center">Leave</span>
							</button>
						</span>




					</div>
				</div>


			</div>


			<confirm-delete-modal :open=deleteModalOpen :data="auth.user.current_team" @close="deleteModalOpen = false"></confirm-delete-modal>
			<confirm-leave-modal :open=leaveModalOpen :data="auth.user.current_team" @close="leaveModalOpen = false"></confirm-leave-modal>


		</div>
	</div>
</template>
